import styled from 'styled-components'
import { breakpoints } from '../../constants'
import {
	BLUE,
	WHITE,
	MEDIUMORANGE,
	STRONGORANGE,
	PLACEHOLDERGRAY,
	INPUTGRAY,
	GREEN,
	GRAY,
	PRIMARY_COLOR,
	RED,
} from '../../styles/colors.style'

export const Container = styled.section`
	margin-top: 0;
	background: ${BLUE};
	display: flex;
	flex-direction: column;
	@media (min-width: ${breakpoints.MOBILE}px) {
		margin-top: -120px;
	}
`

export const Header = styled.header`
	background: ${MEDIUMORANGE};
	color: ${WHITE};
	height: 140px;
	text-align: center;

	&.hide {
		display: none;
	}
	.title {
		padding-top: 20px;
		span {
			padding: 3px 35px;
			background: ${STRONGORANGE};
			font: bold 18px/33px 'Source Sans Pro';
			height: 33px;
			margin: 0 auto;
		}
	}
	p {
		font: bold 18px 'Source Sans Pro';
		max-width: 310px;
		margin: 12px auto;
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
		height: 119px;
		width: 749px;
		margin: 0 auto 10px;
		border-radius: 0 0 32px 32px;

		p {
			max-width: 558px;
		}
	}
`
export const Register = styled.section`
	display: flex;
	flex-direction: column;
`

export const Paragraph = styled.p`
	width: 100% !important;
`

export const Steper = styled.nav`
	max-width: 342px;
	margin: 20px auto;

	&.hide {
		display: none;
	}

	ul {
		counter-reset: step;
		padding: 0;
		display: flex;

		li {
			list-style: none;
			color: ${WHITE};
			width: 50%;
			position: relative;
			text-align: center;

			&:before {
				content: counter(step);
				counter-increment: step;
				width: 30px;
				height: 30px;
				line-height: 27px;
				border: 2px solid transparent;
				display: block;
				text-align: center;
				margin: 0 auto 10px auto;
				border-radius: 50%;
				background: ${WHITE};
				color: ${BLUE};
				font-weight: 600;
				position: relative;
				z-index: 1;
			}
			&:after {
				content: '';
				position: absolute;
				width: 100%;
				height: 8px;
				background: ${WHITE};
				top: 12px;
				left: -50%;
				z-index: 0;
			}
			&:first-child {
				&:after {
					content: none;
				}
			}

			&.active {
				&:before {
					border-color: ${MEDIUMORANGE};
				}
			}

			&.active {
				+ {
					.active {
						&:after {
							background: ${MEDIUMORANGE};
						}
					}
				}
			}

			&.before {
				+ {
					.before {
						&:after {
							background: ${MEDIUMORANGE};
						}
					}
				}
				&:before {
					background: ${GREEN};
					color: ${WHITE};
					border-color: ${GREEN};
				}
			}
			&.before {
				+ {
					.active {
						&:after {
							background: ${MEDIUMORANGE};
						}
					}
				}
			}
		}
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
	}
`
export const CustomizedErrorMessage = styled.div`
	color: #9d0000;
`

export const Box = styled.div`
	display: flex;
	flex-direction: column;
	color: ${WHITE};
	align-items: center;
	margin: 0 auto 40px auto;
	min-height: 30vh;

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 342px;
	}

	.safari-force-centering {
		margin: 0 auto !important;
	}

	.field {
		flex: 1;
		text-align: center;
		h5 {
			text-align: center;
			font: bold 18px/22px 'Source Sans Pro';
			margin-bottom: 20px;
		}

		.msg-error {
			color: ${RED};
			margin-bottom: 7px;
		}

		input {
			border-radius: 6px;
			background: ${WHITE};
			height: 45px;
			box-sizing: border-box;
			padding: 0 4px;
			border: 1px solid ${INPUTGRAY};
			outline: none;
			margin-bottom: 10px;
			font: 16px/45px 'Source Sans Pro';
			color: ${GRAY};
			width: 300px;
			@media (max-width: 600px) {
				width: 100%;
			}
			&.input-medium {
				width: 262px;

				@media (min-width: ${breakpoints.MOBILE}px) {
					width: 342px;
				}
			}

			&.field-error {
				border: 1px solid ${PRIMARY_COLOR};
				box-shadow: 0 0 10px ${PRIMARY_COLOR};
			}

			&.input-big {
				width: 337px;
			}

			&::-webkit-input-placeholder,
			&:-ms-input-placeholder,
			&::placeholder {
				/* Edge */
				color: ${PLACEHOLDERGRAY};
				font: 16px/45px 'Source Sans Pro';
			}
		}
	}

	.button {
		text-transform: uppercase;
		color: ${WHITE};
		background: ${MEDIUMORANGE};
		text-align: center;
		border: 0;
		width: 260px;
		height: 49px;
		border-radius: 5px;
		font: bold 16px/49px 'Source Sans Pro';
		cursor: pointer;

		&.transparent {
			background: transparent;
		}

		&.disabled {
			opacity: 0.5;
			cursor: initial;
		}
		&:disabled {
			opacity: 0.5;
			cursor: initial;
		}
	}

	.footer {
		display: flex;
		width: 100%;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 90%;
		max-width: 300px;

		@media (min-width: ${breakpoints.MOBILE}px) {
			width: 100%;
			max-width: 342px;
		}

		button {
			width: auto;
			flex-grow: 1;

			&:first-child {
				margin-right: 20px;
			}
		}
	}
`

export const BoxCard = styled.div`
	background: url('../../../assets/static/muvicard.png') no-repeat;
	background-size: cover;
	min-height: 234px;
	display: flex;
	align-items: flex-end;
	padding-bottom: 10px;
	margin: 0 auto;

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 342px;
		min-height: 225px;
	}

	ul {
		list-style: none;
	}
`

export const LinkCard = styled.a`
	display: block;
	width: 260px;
	height: 50px;
	font: 600 16px/50px 'Source Sans Pro';
	text-align: center;
	border-radius: 5px;
	color: ${WHITE};
	margin: 15px auto 15px auto;

	&.orange {
		background: ${MEDIUMORANGE};
	}
	&.blue {
		background: ${BLUE};
	}
	&:hover {
		color: ${WHITE};
	}
`

export const ButtonLink = styled.button`
	background: none !important;
	border: none;
	padding: 0 !important;
	color: ${MEDIUMORANGE};
	cursor: pointer;
`

export const ConclusionPage = styled.section`
	width: 100%;
	height: 100%;
	@media (max-width: ${breakpoints.MOBILE}px) {
		padding-top: 10px;
	}
`
